import React from 'react';
import { AddCaseDetails } from 'pages/components';

const CasesNewAddDetails = (props) => (
  <AddCaseDetails {...props} />
);

export default CasesNewAddDetails;
